/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsGallery = {
  init: function($section) {
    this.$section = $section;
    // Add settings from schema to current object
    Shopify.theme.jsGallery = $.extend(this, Shopify.theme.getSectionData($section));
    let $sliderEl = $section.find('[data-slider]');

    let gutterSize = 0;
    if(this.show_gutter == true) {
      gutterSize = 20
    }

    if(this.gallery_type == 'masonry') {
      Shopify.theme.applyMasonry('.gallery__item', gutterSize);
    } else if(this.gallery_type == 'horizontal-masonry') {
      Shopify.theme.applyHorizontalMasonry();
    }else if(this.gallery_type == 'slider') {
      this.createSlider($sliderEl);
    }
  },
  createSlider: function ($sliderEl) {
    let $progressBar = this.$section.find('.progress-bar');

    const slider = $sliderEl.flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {          
        scroll: function(progress) {          
          progress = Math.max( 0.1, Math.min( 1, progress ) );
          $progressBar.css('width', (progress * 100) + "%");
        }
      }
    });
    slider.on('settle.flickity', function () {
      slider.flickity('resize');
    });
  
  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;